var TableDisplaySizes;
(function (TableDisplaySizes) {
    TableDisplaySizes["SMALL"] = "small";
    TableDisplaySizes["MEDIUM"] = "medium";
    TableDisplaySizes["LARGE"] = "large";
})(TableDisplaySizes || (TableDisplaySizes = {}));

export { TableDisplaySizes };
//# sourceMappingURL=types.js.map
